import { createContext } from 'react'

import { LawyerContextProps } from '../interfaces'

export const LawyerContext = createContext<LawyerContextProps>({
  powerBI: null,
})
